import React, { useEffect, useRef } from "react";
import styles from "./extract-image-templet.module.css";
import Portrait from "../savior/portrait/portrait";
import { EQUIP_PART_TYPE, LOCALES, NORMAL_STATUS_TYPE, SAVIOR_ATTRIBUTE, SKILL_TYPE } from "../../constants";
import getImageFileName from "../../functions/getImageFileName";
import { getPotentialBgKey } from "../../functions/getPotentialFunctions";
import Decimal from "decimal.js";
import { getUIText } from "../../translation";

const ATTR_ENG = {
    태양: "sun",
    달: "moon",
    별: "star",
    질서: "order",
    혼돈: "chaos",
};

const STAT_TYPE = {
    atk: "공격력",
    hp: "생명력",
    def: "방어력",
    spd: "속도",
    crit_rate: "치명타 확률",
    crit_dmg: "치명타 대미지",
    eff_rate: "효과 적중",
    eff_resist: "효과 저항",
};

export default function ExtractImageTemplet({
    lang,
    savior,
    saviorPreset,
    archivePreset,
    equipPreset,
    totalStat,
    onReady,
    potentialsOrigin,
    setOrigin,
}) {
    if (
        savior === undefined ||
        saviorPreset === undefined ||
        archivePreset === undefined ||
        equipPreset === undefined ||
        totalStat === undefined
    )
        return;

    const containerRef = useRef(null);

    useEffect(() => {
        if (!containerRef.current) return;
        const imgs = containerRef.current.querySelectorAll("img");
        Promise.all([...imgs].map((img) => (img.complete ? Promise.resolve() : new Promise((r) => (img.onload = r))))).then(() =>
            onReady(),
        );
        // onReady(); // 렌더 완료 후 resolve
    }, [containerRef.current]);

    // if (!potentialsOrigin || !setOrigin) return;

    return (
        <div
            className={`${styles["extract-image-container"]} ${styles[SAVIOR_ATTRIBUTE[savior.attr][LOCALES.EN].toLowerCase()]}`}
            ref={containerRef}
        >
            <div className={styles["column-container"]}>
                <div className={styles["savior-preset"]}>
                    <div className={styles["savior-info"]}>
                        <Portrait savior={savior} isSmall={true} />
                        <div className={styles["summary"]}>
                            <div className={styles["savior-name"]}>{savior.name[lang]}</div>
                            <div className={styles["levels"]}>
                                <div className={`${styles["level"]} ${saviorPreset.limitBreak === 0 ? `${styles["padding-right"]}` : ""}`}>
                                    Lv.{saviorPreset.level}
                                </div>
                                {saviorPreset.limitBreak !== 0 && (
                                    <div className={styles["icon-container"]}>
                                        {new Array(saviorPreset.limitBreak).fill(null, 0, saviorPreset.limitBreak).map((_, index) => {
                                            return (
                                                <img
                                                    key={`limit_break_${index}`}
                                                    className={styles["limit-break"]}
                                                    src={`${process.env.PUBLIC_URL}/images/icon/portrait/limitBreak.webp`}
                                                />
                                            );
                                        })}
                                    </div>
                                )}
                                {saviorPreset.starGrade !== 0 && (
                                    <div className={`${styles["icon-container"]} ${styles["star-grade"]}`}>
                                        <img
                                            className={styles["star-grade-bg"]}
                                            src={`${process.env.PUBLIC_URL}/images/icon/portrait/starGrade.webp`}
                                        />
                                        <span>{saviorPreset.starGrade}</span>
                                    </div>
                                )}
                                <div className={`${styles["icon-container"]} ${styles["star-grade"]}`}>
                                    <img className={styles["favor-bg"]} src={`${process.env.PUBLIC_URL}/images/icon/portrait/favor.webp`} />
                                    <span>{saviorPreset.favor}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={styles["skills"]}>
                        {savior.skills.map((skill, skillIndex) => {
                            return (
                                <div className={styles["skill"]} key={`skill_${skillIndex}`}>
                                    <div className={styles["skill-icon-wrapper"]}>
                                        <img
                                            className={styles["skill-frame"]}
                                            src={`${process.env.PUBLIC_URL}/images/icon/skills/skillFrame.webp`}
                                        />
                                        <img
                                            className={styles["skill-icon"]}
                                            src={`${process.env.PUBLIC_URL}/images/icon/skills/${savior.name[LOCALES.KO]}(${savior.title[LOCALES.KO]})_${SKILL_TYPE[skill.type][LOCALES.KO]}.webp`}
                                        />
                                        <img
                                            src={`${process.env.PUBLIC_URL}/images/icon/skills/skillBg_${SAVIOR_ATTRIBUTE[savior.attr][LOCALES.EN].toLowerCase()}.webp`}
                                        />
                                    </div>
                                    <div className={styles["skill-info"]}>
                                        <div className={styles["skill-name"]}>{skill.name[lang]}</div>
                                        <div className={styles["skill-level"]}>
                                            Lv.{saviorPreset.skillLevels[skillIndex] + (skill.type === 0 ? saviorPreset.limitBreak : 0)}
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
            <div className={styles["column-container"]}>
                <div className={styles["archive-preset"]}>
                    <table className={styles["archive-stats"]}>
                        <tbody>
                            <tr>
                                <td>
                                    <img src={`${process.env.PUBLIC_URL}/images/icon/journey_status/힘.webp`} />
                                </td>
                                <td>
                                    <img src={`${process.env.PUBLIC_URL}/images/icon/journey_status/체력.webp`} />
                                </td>
                                <td>
                                    <img src={`${process.env.PUBLIC_URL}/images/icon/journey_status/인내.webp`} />
                                </td>
                                <td>
                                    <img src={`${process.env.PUBLIC_URL}/images/icon/journey_status/집중.webp`} />
                                </td>
                                <td>
                                    <img src={`${process.env.PUBLIC_URL}/images/icon/journey_status/보호.webp`} />
                                </td>
                            </tr>
                            <tr>
                                <td>{archivePreset.stat.str}</td>
                                <td>{archivePreset.stat.hp}</td>
                                <td>{archivePreset.stat.end}</td>
                                <td>{archivePreset.stat.focus}</td>
                                <td>{archivePreset.stat.prot}</td>
                            </tr>
                        </tbody>
                    </table>
                    {archivePreset.potentials.length > 0 && (
                        <div className={styles["potentials"]}>
                            {archivePreset.potentials
                                .sort((a, b) => a.id - b.id)
                                .map((poten) => {
                                    const potential = potentialsOrigin.find((e) => e.id === poten.id);
                                    const src = `${process.env.PUBLIC_URL}/images/icon/potential/bg_${getPotentialBgKey(potential)}.webp`;

                                    return (
                                        <div className={styles["potential"]} key={`potential_${poten.id}`}>
                                            <div className={styles["potential-icon-wrapper"]}>
                                                <img
                                                    className={styles["potential-icon"]}
                                                    src={`${process.env.PUBLIC_URL}/images/icon/potential/${getImageFileName(poten.name[LOCALES.KO])}.webp`}
                                                />
                                                <img className={styles["potential-bg"]} src={src} />
                                            </div>
                                            <div className={styles["potential-name"]}>{poten.name[lang]}</div>
                                            <div className={styles["potential-level"]}>Lv.{poten.level}</div>
                                        </div>
                                    );
                                })}
                        </div>
                    )}
                </div>
            </div>
            <div className={styles["column-container"]}>
                {[0, 1, 2].map((part) => {
                    const equip = equipPreset.equips[part];
                    const set = setOrigin.find((e) => e.id === equip.setId);

                    return (
                        <div
                            className={`${styles["equipment"]} ${equip.isEngraved ? `${styles["engraved"]}` : ""} `}
                            key={`view_equip_${part}`}
                        >
                            <div className={styles["equipment-summary-wrapper"]}>
                                {equip.name !== "" && (
                                    <div
                                        className={`${styles["equip-image"]} ${equip.grade === 2 ? `${styles["unique"]}` : `${styles["legendary"]}`}`}
                                    >
                                        <img src={`${process.env.PUBLIC_URL}/images/icon/equipments/${equip.img}`} />
                                        {equip.isEngraved && (
                                            <img
                                                className={styles["frame"]}
                                                src={`${process.env.PUBLIC_URL}/images/icon/equipments/engraved.webp`}
                                            />
                                        )}
                                    </div>
                                )}
                                {equip.name === "" && <div className={styles["equip-image"]}>{EQUIP_PART_TYPE[equip.part][lang]}</div>}
                                <div className={styles["equipment-summary"]}>
                                    <div className={styles["equipment-name-wrapper"]}>
                                        <div className={styles["equipment-name"]}>
                                            {equip.name !== ""
                                                ? `${equip.name[lang]} +${equip.enhanced}`
                                                : getUIText(lang, "simulator.savior.equip.each.basic.title")}
                                        </div>
                                    </div>
                                    {set && (
                                        <div className={styles["equipment-set"]}>
                                            <img src={`${process.env.PUBLIC_URL}/images/icon/equipments/${set.img}`} />
                                            <span>{set.name[lang]}</span>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className={styles["equipment-info"]}>
                                {equipPreset.slot !== 0 && (
                                    <div className={styles["equipment-stat-wrapper"]}>
                                        <div className={styles["equipment-stat"]}>
                                            <div className={styles["stat-name"]}>{NORMAL_STATUS_TYPE[equip.mainOption.statType][lang]}</div>
                                            <div className={styles["stat-value"]}>
                                                {equip.mainOption.isPercent
                                                    ? `+${(equip.mainOption.baseValue + equip.mainOption.gap * (equip.enhanced + (equip.isEngraved ? 3 : 0))) / 100}%`
                                                    : ""}
                                                {!equip.mainOption.isPercent
                                                    ? `+${equip.mainOption.baseValue + equip.mainOption.gap * (equip.enhanced + (equip.isEngraved ? 3 : 0))}`
                                                    : ""}
                                            </div>
                                        </div>
                                        <hr className={styles["stat-divider"]} />
                                    </div>
                                )}
                                {equipPreset.slot !== 0 &&
                                    Object.keys(STAT_TYPE).map((statType) => {
                                        const intList = equip.subOptions.filter((e) => e.statType === statType && e.isPercent === false);
                                        const percentList = equip.subOptions.filter((e) => e.statType === statType && e.isPercent === true);

                                        let int = 0;
                                        intList.forEach((e) => (int += e.value));

                                        let percent = 0;
                                        percentList.forEach((e) => (percent += e.value));

                                        if (int === 0 && percent === 0) return;

                                        return (
                                            <div
                                                className={styles["equipment-stat-wrapper"]}
                                                key={`view_equip_part_${equip.part}_stat_${statType}`}
                                            >
                                                <div className={styles["equipment-stat"]}>
                                                    <div className={styles["stat-name"]}>{NORMAL_STATUS_TYPE[statType][lang]}</div>
                                                    <div className={styles["stat-value"]}>
                                                        {int !== 0 && `(+${int})`} {percent !== 0 && `(+${percent / 100}%)`}
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                            </div>
                        </div>
                    );
                })}
            </div>
            <div className={styles["column-container"]}>
                {[3, 4, 5].map((part) => {
                    const equip = equipPreset.equips[part];
                    const set = setOrigin.find((e) => e.id === equip.setId);

                    return (
                        <div
                            className={`${styles["equipment"]} ${equip.isEngraved ? `${styles["engraved"]}` : ""} `}
                            key={`view_equip_${part}`}
                        >
                            <div className={styles["equipment-summary-wrapper"]}>
                                {equip.name !== "" && (
                                    <div
                                        className={`${styles["equip-image"]} ${equip.grade === 2 ? `${styles["unique"]}` : `${styles["legendary"]}`}`}
                                    >
                                        <img src={`${process.env.PUBLIC_URL}/images/icon/equipments/${equip.img}`} />
                                        {equip.isEngraved && (
                                            <img
                                                className={styles["frame"]}
                                                src={`${process.env.PUBLIC_URL}/images/icon/equipments/engraved.webp`}
                                            />
                                        )}
                                    </div>
                                )}
                                {equip.name === "" && <div className={styles["equip-image"]}>{EQUIP_PART_TYPE[equip.part][lang]}</div>}
                                <div className={styles["equipment-summary"]}>
                                    <div className={styles["equipment-name-wrapper"]}>
                                        <div className={styles["equipment-name"]}>
                                            {equip.name !== ""
                                                ? `${equip.name[lang]} +${equip.enhanced}`
                                                : getUIText(lang, "simulator.savior.equip.each.basic.title")}
                                        </div>
                                    </div>
                                    {set && (
                                        <div className={styles["equipment-set"]}>
                                            <img src={`${process.env.PUBLIC_URL}/images/icon/equipments/${set.img}`} />
                                            <span>{set.name[lang]}</span>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className={styles["equipment-info"]}>
                                {equipPreset.slot !== 0 && (
                                    <div className={styles["equipment-stat-wrapper"]}>
                                        <div className={styles["equipment-stat"]}>
                                            <div className={styles["stat-name"]}>{NORMAL_STATUS_TYPE[equip.mainOption.statType][lang]}</div>
                                            <div className={styles["stat-value"]}>
                                                {equip.mainOption.isPercent
                                                    ? `+${(equip.mainOption.baseValue + equip.mainOption.gap * (equip.enhanced + (equip.isEngraved ? 3 : 0))) / 100}%`
                                                    : ""}
                                                {!equip.mainOption.isPercent
                                                    ? `+${equip.mainOption.baseValue + equip.mainOption.gap * (equip.enhanced + (equip.isEngraved ? 3 : 0))}`
                                                    : ""}
                                            </div>
                                        </div>
                                        <hr className={styles["stat-divider"]} />
                                    </div>
                                )}
                                {equipPreset.slot !== 0 &&
                                    Object.keys(STAT_TYPE).map((statType) => {
                                        const intList = equip.subOptions.filter((e) => e.statType === statType && e.isPercent === false);
                                        const percentList = equip.subOptions.filter((e) => e.statType === statType && e.isPercent === true);

                                        let int = 0;
                                        intList.forEach((e) => (int += e.value));

                                        let percent = 0;
                                        percentList.forEach((e) => (percent += e.value));

                                        if (int === 0 && percent === 0) return;

                                        return (
                                            <div
                                                className={styles["equipment-stat-wrapper"]}
                                                key={`view_equip_part_${equip.part}_stat_${statType}`}
                                            >
                                                <div className={styles["equipment-stat"]}>
                                                    <div className={styles["stat-name"]}>{NORMAL_STATUS_TYPE[statType][lang]}</div>
                                                    <div className={styles["stat-value"]}>
                                                        {int !== 0 && `(+${int})`} {percent !== 0 && `(+${percent / 100}%)`}
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                            </div>
                        </div>
                    );
                })}
            </div>
            <div className={styles["column-container"]}>
                <div className={styles["total-stat-container"]}>
                    <div className={styles["option"]}>
                        <div className={styles["title"]}>{getUIText(lang, "simulator.total.combatPower")}</div>
                        <div className={styles["value"]}>{totalStat.battle_power.toLocaleString("ko-KR")}</div>
                    </div>
                    <div className={styles["stats"]}>
                        <div className={styles["option"]}>
                            <div className={styles["title"]}>{getUIText(lang, "simulator.total.atk")}</div>
                            <div className={styles["value"]}>{totalStat.atk.toLocaleString("ko-KR")}</div>
                        </div>
                        <div className={styles["option"]}>
                            <div className={styles["title"]}>{getUIText(lang, "simulator.total.hp")}</div>
                            <div className={styles["value"]}>{totalStat.hp.toLocaleString("ko-KR")}</div>
                        </div>
                        <div className={styles["option"]}>
                            <div className={styles["title"]}>{getUIText(lang, "simulator.total.def")}</div>
                            <div className={styles["value"]}>{totalStat.def.toLocaleString("ko-KR")}</div>
                        </div>
                        <div className={styles["option"]}>
                            <div className={styles["title"]}>{getUIText(lang, "simulator.total.spd")}</div>
                            <div className={styles["value"]}>{totalStat.spd.toLocaleString("ko-KR")}</div>
                        </div>
                        <div className={styles["option"]}>
                            <div className={styles["title"]}>{getUIText(lang, "simulator.total.critRate")}</div>
                            <div className={styles["value"]}>
                                {new Decimal(totalStat.crit_rate).div(100).toNumber().toLocaleString("ko-KR")}%
                            </div>
                        </div>
                        <div className={styles["option"]}>
                            <div className={styles["title"]}>{getUIText(lang, "simulator.total.critDmg")}</div>
                            <div className={styles["value"]}>
                                {new Decimal(totalStat.crit_dmg).div(100).toNumber().toLocaleString("ko-KR")}%
                            </div>
                        </div>
                        <div className={styles["option"]}>
                            <div className={styles["title"]}>{getUIText(lang, "simulator.total.effRate")}</div>
                            <div className={styles["value"]}>
                                {new Decimal(totalStat.eff_rate).div(100).toNumber().toLocaleString("ko-KR")}%
                            </div>
                        </div>
                        <div className={styles["option"]}>
                            <div className={styles["title"]}>{getUIText(lang, "simulator.total.effResist")}</div>
                            <div className={styles["value"]}>
                                {new Decimal(totalStat.eff_resist).div(100).toNumber().toLocaleString("ko-KR")}%
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
